import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative border border-gray-200 dark:border-gray-700 bg-white dark:bg-black rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" }
const _hoisted_3 = { class: "sticky top-0 bg-white dark:bg-black border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between z-10" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/20 flex items-center justify-center mr-3" }
const _hoisted_6 = { class: "px-6 py-6" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = { class: "mb-6" }
const _hoisted_10 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_11 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_12 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_13 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_14 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_15 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_16 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_17 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_18 = { class: "mt-1 text-gray-900 dark:text-white font-medium break-all" }
const _hoisted_19 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_20 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_21 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_22 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_23 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_24 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_25 = { class: "mb-6" }
const _hoisted_26 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_27 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_28 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_29 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_30 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_31 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_32 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_33 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_34 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_35 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_36 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_37 = { class: "mb-6" }
const _hoisted_38 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_39 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_40 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_41 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_42 = { class: "mt-1 text-2xl font-bold text-gray-900 dark:text-white" }
const _hoisted_43 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_44 = { class: "mt-1 text-2xl font-bold text-gray-900 dark:text-white" }
const _hoisted_45 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_46 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_47 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_48 = { class: "space-y-4" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "flex items-center justify-between" }
const _hoisted_51 = { class: "flex items-center space-x-3" }
const _hoisted_52 = {
  class: "w-10 h-10 rounded-lg flex items-center justify-center",
  style: { backgroundColor: 'var(--brand-primary)' + '15' }
}
const _hoisted_53 = {
  class: "w-6 h-6",
  style: { color: 'var(--brand-primary)' },
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_54 = { class: "text-base font-semibold text-gray-900 dark:text-white" }
const _hoisted_55 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_56 = { class: "flex items-center space-x-3" }
const _hoisted_57 = {
  class: "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium",
  style: {
                              backgroundColor: 'var(--brand-accent)' + '20',
                              color: 'var(--brand-accent)'
                            }
}
const _hoisted_58 = { class: "relative group inline-block" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "font-medium" }
const _hoisted_61 = {
  key: 1,
  class: "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-400"
}
const _hoisted_62 = {
  key: 2,
  class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1.5 w-max text-xs text-white bg-gray-900 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-[9999]"
}
const _hoisted_63 = {
  key: 0,
  class: "bg-white dark:bg-black px-4 py-3"
}
const _hoisted_64 = {
  key: 0,
  class: "text-center py-8 text-gray-500 dark:text-gray-400"
}
const _hoisted_65 = {
  key: 1,
  class: "grid grid-cols-1 lg:grid-cols-2 gap-3"
}
const _hoisted_66 = { class: "flex items-start justify-between mb-3" }
const _hoisted_67 = { class: "flex items-center space-x-2" }
const _hoisted_68 = {
  class: "w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0",
  style: { backgroundColor: 'var(--brand-accent)' + '15' }
}
const _hoisted_69 = {
  class: "w-5 h-5",
  style: { color: 'var(--brand-accent)' },
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_70 = { class: "text-sm font-semibold text-gray-900 dark:text-white" }
const _hoisted_71 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_72 = {
  key: 0,
  class: "inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300"
}
const _hoisted_73 = {
  key: 1,
  class: "inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300"
}
const _hoisted_74 = {
  key: 2,
  class: "inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300"
}
const _hoisted_75 = { class: "space-y-2 text-xs" }
const _hoisted_76 = { class: "flex justify-between" }
const _hoisted_77 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_78 = { class: "flex justify-between" }
const _hoisted_79 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_80 = { class: "flex justify-between" }
const _hoisted_81 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_82 = { class: "flex justify-between" }
const _hoisted_83 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_84 = { class: "flex justify-between" }
const _hoisted_85 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_86 = { class: "flex justify-between items-center" }
const _hoisted_87 = { class: "relative group inline-block" }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = { class: "font-medium" }
const _hoisted_90 = {
  key: 1,
  class: "inline-flex items-center text-gray-400"
}
const _hoisted_91 = {
  key: 2,
  class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1.5 w-max text-xs text-white bg-gray-900 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-[9999]"
}
const _hoisted_92 = {
  key: 0,
  class: "mt-3 pt-3 border-t border-gray-200 dark:border-gray-600"
}
const _hoisted_93 = { class: "text-xs text-gray-700 dark:text-gray-300" }
const _hoisted_94 = {
  key: 1,
  class: "mt-3 pt-3 border-t border-gray-200 dark:border-gray-600 flex gap-2"
}
const _hoisted_95 = ["onClick"]
const _hoisted_96 = ["onClick"]
const _hoisted_97 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_98 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_99 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_100 = { class: "sticky bottom-0 bg-gray-50 dark:bg-black border-t border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-end space-x-3" }
const _hoisted_101 = { class: "bg-black bg-opacity-75 text-white px-6 py-3 rounded-t-lg mb-2 w-full" }
const _hoisted_102 = { class: "flex items-center justify-between" }
const _hoisted_103 = { class: "text-lg font-semibold" }
const _hoisted_104 = { class: "text-sm text-gray-300" }
const _hoisted_105 = { class: "text-sm text-gray-300" }
const _hoisted_106 = ["src", "alt"]
const _hoisted_107 = ["onClick"]
const _hoisted_108 = ["src", "alt"]
const _hoisted_109 = { class: "bg-black bg-opacity-75 text-white px-6 py-3 rounded-t-lg mb-2 w-full" }
const _hoisted_110 = { class: "flex items-center justify-between" }
const _hoisted_111 = { class: "text-lg font-semibold" }
const _hoisted_112 = { class: "text-sm text-gray-300" }
const _hoisted_113 = { class: "text-sm text-gray-300" }
const _hoisted_114 = ["src", "alt"]
const _hoisted_115 = ["onClick"]
const _hoisted_116 = ["src", "alt"]
const _hoisted_117 = { class: "mt-6 flex gap-3 justify-end" }
const _hoisted_118 = ["disabled"]

import { ref } from 'vue';
import type { Customer, Tire, Vehicle } from '@/types/customer';
import ViewIcon from '@/components/icons/ViewIcon.vue';
import { tireService } from '@/services/api/tireService';
import { useToast } from 'vue-toastification';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDetailsModal',
  props: {
    isOpen: { type: Boolean },
    customer: {}
  },
  emits: ["close", "edit", "refresh"],
  setup(__props: any, { emit: __emit }) {

const toast = useToast();



const emit = __emit;

// Track expanded vehicles
const expandedVehicles = ref<number[]>([]);

// Tire receipt photo gallery state
const photoGalleryOpen = ref(false);
const selectedTire = ref<Tire | null>(null);
const currentPhotoIndex = ref(0);

// Vehicle photo gallery state
const vehiclePhotoGalleryOpen = ref(false);
const selectedVehicle = ref<Vehicle | null>(null);
const currentVehiclePhotoIndex = ref(0);

// Tire rejection modal state
const showTireRejectModal = ref(false);
const selectedTireForReject = ref<Tire | null>(null);
const tireRejectionReason = ref('');

function toggleVehicle(vehicleId: number) {
  const index = expandedVehicles.value.indexOf(vehicleId);
  if (index > -1) {
    expandedVehicles.value.splice(index, 1);
  } else {
    expandedVehicles.value.push(vehicleId);
  }
}

function openPhotoGallery(tire: Tire) {
  selectedTire.value = tire;
  currentPhotoIndex.value = 0;
  photoGalleryOpen.value = true;
}

function closePhotoGallery() {
  photoGalleryOpen.value = false;
  selectedTire.value = null;
  currentPhotoIndex.value = 0;
}

function previousPhoto() {
  if (currentPhotoIndex.value > 0) {
    currentPhotoIndex.value--;
  }
}

function nextPhoto() {
  if (selectedTire.value?.receipt_photos && currentPhotoIndex.value < selectedTire.value.receipt_photos.length - 1) {
    currentPhotoIndex.value++;
  }
}

function openVehiclePhotoGallery(vehicle: Vehicle) {
  selectedVehicle.value = vehicle;
  currentVehiclePhotoIndex.value = 0;
  vehiclePhotoGalleryOpen.value = true;
}

function closeVehiclePhotoGallery() {
  vehiclePhotoGalleryOpen.value = false;
  selectedVehicle.value = null;
  currentVehiclePhotoIndex.value = 0;
}

function previousVehiclePhoto() {
  if (currentVehiclePhotoIndex.value > 0) {
    currentVehiclePhotoIndex.value--;
  }
}

function nextVehiclePhoto() {
  if (selectedVehicle.value?.vehicle_photos && currentVehiclePhotoIndex.value < selectedVehicle.value.vehicle_photos.length - 1) {
    currentVehiclePhotoIndex.value++;
  }
}

function getPhotoUrl(path: string): string {
  const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000';
  // const baseUrl = process.env.VUE_APP_API_URL?.replace('/api', '') || 'http://localhost:8000';
  return `${baseUrl}/storage/${path}`;
}

function getStatusClass(status: string): string {
  switch (status) {
    case 'pending':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400';
    case 'active':
      return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
    case 'rejected':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-black/30 dark:text-gray-400';
  }
}

function getStatusDotClass(status: string): string {
  switch (status) {
    case 'pending':
      return 'bg-yellow-500 dark:bg-yellow-400';
    case 'active':
      return 'bg-green-500 dark:bg-green-400';
    case 'rejected':
      return 'bg-red-500 dark:bg-red-400';
    default:
      return 'bg-gray-500 dark:bg-gray-400';
  }
}

function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

// Tire approval methods
async function approveTireInline(tire: Tire) {
  try {
    await tireService.approveTire(tire.tire_id);
    toast.success('Tire approved successfully');
    emit('refresh');
  } catch (error: any) {
    toast.error(error.response?.data?.message || 'Failed to approve tire');
  }
}

function openRejectModalInline(tire: Tire) {
  selectedTireForReject.value = tire;
  tireRejectionReason.value = '';
  showTireRejectModal.value = true;
}

function closeTireRejectModal() {
  showTireRejectModal.value = false;
  selectedTireForReject.value = null;
  tireRejectionReason.value = '';
}

async function confirmTireReject() {
  if (!selectedTireForReject.value || !tireRejectionReason.value.trim()) return;

  try {
    await tireService.rejectTire(selectedTireForReject.value.tire_id, tireRejectionReason.value);
    toast.success('Tire rejected successfully');
    closeTireRejectModal();
    emit('refresh');
  } catch (error: any) {
    toast.error(error.response?.data?.message || 'Failed to reject tire');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "modal" }, {
        default: _withCtx(() => [
          (_ctx.isOpen && _ctx.customer)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 z-40 overflow-y-auto",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
              }, [
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(ViewIcon, { classes: "h-5 w-5 text-blue-600 dark:text-blue-400" })
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Customer Details ", -1))
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                        class: "text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors duration-200"
                      }, _cache[13] || (_cache[13] = [
                        _createElementVNode("svg", {
                          class: "h-6 w-6",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          })
                        ], -1)
                      ]))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2 block" }, " Account Status ", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass([getStatusClass(_ctx.customer.status), "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium"])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["w-2 h-2 rounded-full mr-2", getStatusDotClass(_ctx.customer.status)])
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(_ctx.customer.status), 1)
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2 block" }, " Category ", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium", _ctx.customer.category === 'internal'
                    ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/20 dark:text-amber-400'
                    : 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400'])
                        }, _toDisplayString(_ctx.customer.category === 'internal' ? 'Internal' : 'Customer'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("h3", _hoisted_10, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[16] || (_cache[16] = [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                              "clip-rule": "evenodd"
                            }, null, -1)
                          ]))),
                          _cache[17] || (_cache[17] = _createTextVNode(" Personal Information "))
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _cache[18] || (_cache[18] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "First Name", -1)),
                            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.customer.first_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _cache[19] || (_cache[19] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Last Name", -1)),
                            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.customer.last_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _cache[20] || (_cache[20] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Email Address", -1)),
                            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.customer.email), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _cache[21] || (_cache[21] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Mobile Number", -1)),
                            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.customer.userDetail?.mobile || _ctx.customer.user_detail?.mobile || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _cache[22] || (_cache[22] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Brand", -1)),
                            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.customer.brand?.brand_name || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _cache[23] || (_cache[23] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Joined Date", -1)),
                            _createElementVNode("p", _hoisted_24, _toDisplayString(formatDate(_ctx.customer.created_at)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("h3", _hoisted_26, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_27, _cache[24] || (_cache[24] = [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
                              "clip-rule": "evenodd"
                            }, null, -1)
                          ]))),
                          _cache[25] || (_cache[25] = _createTextVNode(" Address Information "))
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _cache[26] || (_cache[26] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "House No.", -1)),
                            _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.customer.userDetail?.house_no || _ctx.customer.user_detail?.house_no || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _cache[27] || (_cache[27] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Street", -1)),
                            _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.customer.userDetail?.street || _ctx.customer.user_detail?.street || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _cache[28] || (_cache[28] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Barangay", -1)),
                            _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.customer.userDetail?.barangay || _ctx.customer.user_detail?.barangay || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _cache[29] || (_cache[29] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "City", -1)),
                            _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.customer.userDetail?.city || _ctx.customer.user_detail?.city || 'N/A'), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("h3", _hoisted_38, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_39, _cache[30] || (_cache[30] = [
                            _createElementVNode("path", { d: "M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" }, null, -1)
                          ]))),
                          _cache[31] || (_cache[31] = _createTextVNode(" Statistics "))
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _cache[32] || (_cache[32] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Total Vehicles", -1)),
                            _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.customer.vehicles?.length || 0), 1)
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _cache[33] || (_cache[33] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide",
                              style: {"color":"var(--brand-primary)"}
                            }, "Total Tires", -1)),
                            _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.customer.tires_count || 0), 1)
                          ])
                        ])
                      ]),
                      (_ctx.customer.vehicles && _ctx.customer.vehicles.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("h3", _hoisted_46, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_47, _cache[34] || (_cache[34] = [
                                _createElementVNode("path", { d: "M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }, null, -1),
                                _createElementVNode("path", { d: "M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" }, null, -1)
                              ]))),
                              _createTextVNode(" Vehicles (" + _toDisplayString(_ctx.customer.vehicles.length) + ") ", 1)
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer.vehicles, (vehicle) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: vehicle.vehicle_id,
                                  class: "border border-gray-200 dark:border-gray-700 rounded-lg"
                                }, [
                                  _createElementVNode("div", {
                                    class: "bg-gray-50 dark:bg-black px-4 py-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors duration-200",
                                    onClick: ($event: any) => (toggleVehicle(vehicle.vehicle_id))
                                  }, [
                                    _createElementVNode("div", _hoisted_50, [
                                      _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("div", _hoisted_52, [
                                          (_openBlock(), _createElementBlock("svg", _hoisted_53, _cache[35] || (_cache[35] = [
                                            _createElementVNode("path", { d: "M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }, null, -1),
                                            _createElementVNode("path", { d: "M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" }, null, -1)
                                          ])))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("h4", _hoisted_54, _toDisplayString(vehicle.vehicle_make) + " " + _toDisplayString(vehicle.vehicle_model) + " " + _toDisplayString(vehicle.vehicle_year), 1),
                                          _createElementVNode("p", _hoisted_55, " Plate: " + _toDisplayString(vehicle.plate_number), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("span", _hoisted_57, _toDisplayString(vehicle.tires?.length || 0) + " " + _toDisplayString(vehicle.tires?.length === 1 ? 'Tire Set' : 'Tire Sets'), 1),
                                        _createElementVNode("div", _hoisted_58, [
                                          (vehicle.vehicle_photos && vehicle.vehicle_photos.length > 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: _withModifiers(($event: any) => (openVehiclePhotoGallery(vehicle)), ["stop"]),
                                                class: "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium transition-all duration-200 hover:shadow-md",
                                                style: {
                                backgroundColor: 'var(--brand-primary)' + '20',
                                color: 'var(--brand-primary)'
                              }
                                              }, [
                                                _cache[36] || (_cache[36] = _createElementVNode("svg", {
                                                  class: "w-3.5 h-3.5 mr-1",
                                                  fill: "currentColor",
                                                  viewBox: "0 0 20 20"
                                                }, [
                                                  _createElementVNode("path", {
                                                    "fill-rule": "evenodd",
                                                    d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
                                                    "clip-rule": "evenodd"
                                                  })
                                                ], -1)),
                                                _createElementVNode("span", _hoisted_60, _toDisplayString(vehicle.vehicle_photos.length), 1),
                                                _cache[37] || (_cache[37] = _createElementVNode("svg", {
                                                  class: "w-3 h-3 ml-1",
                                                  fill: "none",
                                                  viewBox: "0 0 24 24",
                                                  stroke: "currentColor"
                                                }, [
                                                  _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                  }),
                                                  _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                  })
                                                ], -1))
                                              ], 8, _hoisted_59))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_61, _cache[38] || (_cache[38] = [
                                                _createElementVNode("svg", {
                                                  class: "w-3.5 h-3.5 mr-1",
                                                  fill: "currentColor",
                                                  viewBox: "0 0 20 20"
                                                }, [
                                                  _createElementVNode("path", {
                                                    "fill-rule": "evenodd",
                                                    d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
                                                    "clip-rule": "evenodd"
                                                  })
                                                ], -1),
                                                _createElementVNode("span", { class: "font-medium" }, "0", -1)
                                              ]))),
                                          (vehicle.vehicle_photos && vehicle.vehicle_photos.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, " Click to view " + _toDisplayString(vehicle.vehicle_photos.length) + " vehicle " + _toDisplayString(vehicle.vehicle_photos.length === 1 ? 'photo' : 'photos'), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (_openBlock(), _createElementBlock("svg", {
                                          class: _normalizeClass(["w-5 h-5 text-gray-400 transition-transform duration-200", { 'rotate-180': expandedVehicles.value.includes(vehicle.vehicle_id) }]),
                                          fill: "none",
                                          viewBox: "0 0 24 24",
                                          stroke: "currentColor"
                                        }, _cache[39] || (_cache[39] = [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M19 9l-7 7-7-7"
                                          }, null, -1)
                                        ]), 2))
                                      ])
                                    ])
                                  ], 8, _hoisted_49),
                                  (expandedVehicles.value.includes(vehicle.vehicle_id))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                        (!vehicle.tires || vehicle.tires.length === 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, _cache[40] || (_cache[40] = [
                                              _createElementVNode("svg", {
                                                class: "w-12 h-12 mx-auto mb-3 opacity-50",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20"
                                              }, [
                                                _createElementVNode("path", {
                                                  "fill-rule": "evenodd",
                                                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z",
                                                  "clip-rule": "evenodd"
                                                })
                                              ], -1),
                                              _createElementVNode("p", { class: "text-sm" }, "No tires registered for this vehicle", -1)
                                            ])))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vehicle.tires, (tire) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: tire.tire_id,
                                                  class: "border border-gray-200 dark:border-gray-600 rounded-lg p-3 hover:shadow-md transition-shadow duration-200"
                                                }, [
                                                  _createElementVNode("div", _hoisted_66, [
                                                    _createElementVNode("div", _hoisted_67, [
                                                      _createElementVNode("div", _hoisted_68, [
                                                        (_openBlock(), _createElementBlock("svg", _hoisted_69, _cache[41] || (_cache[41] = [
                                                          _createElementVNode("circle", {
                                                            cx: "12",
                                                            cy: "12",
                                                            r: "10",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            fill: "none"
                                                          }, null, -1),
                                                          _createElementVNode("circle", {
                                                            cx: "12",
                                                            cy: "12",
                                                            r: "6",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            fill: "none"
                                                          }, null, -1),
                                                          _createElementVNode("circle", {
                                                            cx: "12",
                                                            cy: "12",
                                                            r: "2",
                                                            fill: "currentColor"
                                                          }, null, -1)
                                                        ])))
                                                      ]),
                                                      _createElementVNode("div", null, [
                                                        _createElementVNode("h5", _hoisted_70, _toDisplayString(tire.brand?.brand_name || 'Unknown Brand'), 1),
                                                        _createElementVNode("p", _hoisted_71, _toDisplayString(tire.pattern), 1)
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      (tire.approval_status === 'pending')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_72, _cache[42] || (_cache[42] = [
                                                            _createElementVNode("svg", {
                                                              class: "w-3 h-3",
                                                              fill: "currentColor",
                                                              viewBox: "0 0 20 20"
                                                            }, [
                                                              _createElementVNode("path", {
                                                                "fill-rule": "evenodd",
                                                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z",
                                                                "clip-rule": "evenodd"
                                                              })
                                                            ], -1),
                                                            _createTextVNode(" Pending ")
                                                          ])))
                                                        : (tire.approval_status === 'approved')
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_73, _cache[43] || (_cache[43] = [
                                                              _createElementVNode("svg", {
                                                                class: "w-3 h-3",
                                                                fill: "currentColor",
                                                                viewBox: "0 0 20 20"
                                                              }, [
                                                                _createElementVNode("path", {
                                                                  "fill-rule": "evenodd",
                                                                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                                                  "clip-rule": "evenodd"
                                                                })
                                                              ], -1),
                                                              _createTextVNode(" Approved ")
                                                            ])))
                                                          : (tire.approval_status === 'rejected')
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_74, _cache[44] || (_cache[44] = [
                                                                _createElementVNode("svg", {
                                                                  class: "w-3 h-3",
                                                                  fill: "currentColor",
                                                                  viewBox: "0 0 20 20"
                                                                }, [
                                                                  _createElementVNode("path", {
                                                                    "fill-rule": "evenodd",
                                                                    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                                                    "clip-rule": "evenodd"
                                                                  })
                                                                ], -1),
                                                                _createTextVNode(" Rejected ")
                                                              ])))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_75, [
                                                    _createElementVNode("div", _hoisted_76, [
                                                      _cache[45] || (_cache[45] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Size:", -1)),
                                                      _createElementVNode("span", _hoisted_77, _toDisplayString(tire.tire_size), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_78, [
                                                      _cache[46] || (_cache[46] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "DOT:", -1)),
                                                      _createElementVNode("span", _hoisted_79, _toDisplayString(tire.dot), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_80, [
                                                      _cache[47] || (_cache[47] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Invoice:", -1)),
                                                      _createElementVNode("span", _hoisted_81, _toDisplayString(tire.invoice_number), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_82, [
                                                      _cache[48] || (_cache[48] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Shop:", -1)),
                                                      _createElementVNode("span", _hoisted_83, _toDisplayString(tire.shop), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_84, [
                                                      _cache[49] || (_cache[49] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Code:", -1)),
                                                      _createElementVNode("span", _hoisted_85, _toDisplayString(tire.code), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_86, [
                                                      _cache[53] || (_cache[53] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Receipt Photos:", -1)),
                                                      _createElementVNode("div", _hoisted_87, [
                                                        (tire.receipt_photos && tire.receipt_photos.length > 0)
                                                          ? (_openBlock(), _createElementBlock("button", {
                                                              key: 0,
                                                              onClick: ($event: any) => (openPhotoGallery(tire)),
                                                              class: "inline-flex items-center px-2 py-1 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200",
                                                              style: { color: 'var(--brand-accent)' }
                                                            }, [
                                                              _cache[50] || (_cache[50] = _createElementVNode("svg", {
                                                                class: "w-3.5 h-3.5 mr-1",
                                                                fill: "currentColor",
                                                                viewBox: "0 0 20 20"
                                                              }, [
                                                                _createElementVNode("path", {
                                                                  "fill-rule": "evenodd",
                                                                  d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
                                                                  "clip-rule": "evenodd"
                                                                })
                                                              ], -1)),
                                                              _createElementVNode("span", _hoisted_89, _toDisplayString(tire.receipt_photos.length), 1),
                                                              _cache[51] || (_cache[51] = _createElementVNode("svg", {
                                                                class: "w-3 h-3 ml-1",
                                                                fill: "none",
                                                                viewBox: "0 0 24 24",
                                                                stroke: "currentColor"
                                                              }, [
                                                                _createElementVNode("path", {
                                                                  "stroke-linecap": "round",
                                                                  "stroke-linejoin": "round",
                                                                  "stroke-width": "2",
                                                                  d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                                }),
                                                                _createElementVNode("path", {
                                                                  "stroke-linecap": "round",
                                                                  "stroke-linejoin": "round",
                                                                  "stroke-width": "2",
                                                                  d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                                })
                                                              ], -1))
                                                            ], 8, _hoisted_88))
                                                          : (_openBlock(), _createElementBlock("span", _hoisted_90, _cache[52] || (_cache[52] = [
                                                              _createElementVNode("svg", {
                                                                class: "w-3.5 h-3.5 mr-1",
                                                                fill: "currentColor",
                                                                viewBox: "0 0 20 20"
                                                              }, [
                                                                _createElementVNode("path", {
                                                                  "fill-rule": "evenodd",
                                                                  d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
                                                                  "clip-rule": "evenodd"
                                                                })
                                                              ], -1),
                                                              _createElementVNode("span", { class: "font-medium" }, "0", -1)
                                                            ]))),
                                                        (tire.receipt_photos && tire.receipt_photos.length > 0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_91, " Click to view " + _toDisplayString(tire.receipt_photos.length) + " " + _toDisplayString(tire.receipt_photos.length === 1 ? 'photo' : 'photos'), 1))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ])
                                                  ]),
                                                  (tire.approval_status === 'rejected' && tire.rejection_reason)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                                        _cache[54] || (_cache[54] = _createElementVNode("p", { class: "text-xs font-medium text-red-600 dark:text-red-400 mb-1" }, "Rejection Reason:", -1)),
                                                        _createElementVNode("p", _hoisted_93, _toDisplayString(tire.rejection_reason), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (tire.approval_status === 'pending')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                                        _createElementVNode("button", {
                                                          onClick: ($event: any) => (approveTireInline(tire)),
                                                          class: "flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white rounded-lg text-xs font-medium transition-colors"
                                                        }, _cache[55] || (_cache[55] = [
                                                          _createElementVNode("svg", {
                                                            class: "w-3.5 h-3.5",
                                                            fill: "currentColor",
                                                            viewBox: "0 0 20 20"
                                                          }, [
                                                            _createElementVNode("path", {
                                                              "fill-rule": "evenodd",
                                                              d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                                              "clip-rule": "evenodd"
                                                            })
                                                          ], -1),
                                                          _createTextVNode(" Approve ")
                                                        ]), 8, _hoisted_95),
                                                        _createElementVNode("button", {
                                                          onClick: ($event: any) => (openRejectModalInline(tire)),
                                                          class: "flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded-lg text-xs font-medium transition-colors"
                                                        }, _cache[56] || (_cache[56] = [
                                                          _createElementVNode("svg", {
                                                            class: "w-3.5 h-3.5",
                                                            fill: "currentColor",
                                                            viewBox: "0 0 20 20"
                                                          }, [
                                                            _createElementVNode("path", {
                                                              "fill-rule": "evenodd",
                                                              d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                              "clip-rule": "evenodd"
                                                            })
                                                          ], -1),
                                                          _createTextVNode(" Reject ")
                                                        ]), 8, _hoisted_96)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_97, [
                            _createElementVNode("h3", _hoisted_98, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_99, _cache[57] || (_cache[57] = [
                                _createElementVNode("path", { d: "M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }, null, -1),
                                _createElementVNode("path", { d: "M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" }, null, -1)
                              ]))),
                              _cache[58] || (_cache[58] = _createTextVNode(" Vehicles "))
                            ]),
                            _cache[59] || (_cache[59] = _createElementVNode("div", { class: "text-center py-12 bg-gray-50 dark:bg-black rounded-lg" }, [
                              _createElementVNode("svg", {
                                class: "w-16 h-16 mx-auto mb-4 text-gray-400 dark:text-gray-500",
                                fill: "currentColor",
                                viewBox: "0 0 20 20"
                              }, [
                                _createElementVNode("path", { d: "M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }),
                                _createElementVNode("path", { d: "M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" })
                              ]),
                              _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400" }, "No vehicles registered yet")
                            ], -1))
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 font-medium"
                      }, " Close "),
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('edit', _ctx.customer))),
                        class: "px-4 py-2 text-white rounded-lg transition-colors duration-200 font-medium",
                        style: {"background-color":"var(--brand-primary)"},
                        onMouseover: _cache[3] || (_cache[3] = (e) => (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--brand-hover)'),
                        onMouseout: _cache[4] || (_cache[4] = (e) => (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--brand-primary)')
                      }, " Edit Customer ", 32)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (photoGalleryOpen.value && selectedTire.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 z-[60] bg-black bg-opacity-95 flex items-center justify-center p-4",
                onClick: closePhotoGallery
              }, [
                _createElementVNode("button", {
                  onClick: closePhotoGallery,
                  class: "absolute top-4 right-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                }, _cache[61] || (_cache[61] = [
                  _createElementVNode("svg", {
                    class: "h-8 w-8",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ])),
                (currentPhotoIndex.value > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _withModifiers(previousPhoto, ["stop"]),
                      class: "absolute left-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                    }, _cache[62] || (_cache[62] = [
                      _createElementVNode("svg", {
                        class: "h-12 w-12",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M15 19l-7-7 7-7"
                        })
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "max-w-7xl max-h-full flex flex-col items-center",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_103, _toDisplayString(selectedTire.value.brand?.brand_name || 'Unknown Brand') + " - " + _toDisplayString(selectedTire.value.pattern), 1),
                        _createElementVNode("p", _hoisted_104, _toDisplayString(selectedTire.value.tire_size) + " | Invoice: " + _toDisplayString(selectedTire.value.invoice_number), 1)
                      ]),
                      _createElementVNode("div", _hoisted_105, " Photo " + _toDisplayString(currentPhotoIndex.value + 1) + " of " + _toDisplayString(selectedTire.value.receipt_photos?.length || 0), 1)
                    ])
                  ]),
                  (selectedTire.value.receipt_photos && selectedTire.value.receipt_photos[currentPhotoIndex.value])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: getPhotoUrl(selectedTire.value.receipt_photos[currentPhotoIndex.value].photo_path),
                        alt: `Receipt ${currentPhotoIndex.value + 1}`,
                        class: "max-w-full max-h-[calc(100vh-200px)] object-contain rounded-lg shadow-2xl"
                      }, null, 8, _hoisted_106))
                    : _createCommentVNode("", true)
                ]),
                (selectedTire.value.receipt_photos && currentPhotoIndex.value < selectedTire.value.receipt_photos.length - 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _withModifiers(nextPhoto, ["stop"]),
                      class: "absolute right-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                    }, _cache[63] || (_cache[63] = [
                      _createElementVNode("svg", {
                        class: "h-12 w-12",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M9 5l7 7-7 7"
                        })
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                (selectedTire.value.receipt_photos && selectedTire.value.receipt_photos.length > 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 bg-black bg-opacity-75 p-3 rounded-lg max-w-full overflow-x-auto",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTire.value.receipt_photos, (photo, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: photo.receipt_photo_id,
                          onClick: ($event: any) => (currentPhotoIndex.value = index),
                          class: _normalizeClass(["flex-shrink-0 w-16 h-16 rounded-md overflow-hidden border-2 transition-all duration-200", currentPhotoIndex.value === index ? 'border-white scale-110' : 'border-gray-600 opacity-60 hover:opacity-100'])
                        }, [
                          _createElementVNode("img", {
                            src: getPhotoUrl(photo.photo_path),
                            alt: `Thumbnail ${index + 1}`,
                            class: "w-full h-full object-cover"
                          }, null, 8, _hoisted_108)
                        ], 10, _hoisted_107))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (vehiclePhotoGalleryOpen.value && selectedVehicle.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 z-[60] bg-black bg-opacity-95 flex items-center justify-center p-4",
                onClick: closeVehiclePhotoGallery
              }, [
                _createElementVNode("button", {
                  onClick: closeVehiclePhotoGallery,
                  class: "absolute top-4 right-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                }, _cache[64] || (_cache[64] = [
                  _createElementVNode("svg", {
                    class: "h-8 w-8",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ])),
                (currentVehiclePhotoIndex.value > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _withModifiers(previousVehiclePhoto, ["stop"]),
                      class: "absolute left-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                    }, _cache[65] || (_cache[65] = [
                      _createElementVNode("svg", {
                        class: "h-12 w-12",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M15 19l-7-7 7-7"
                        })
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "max-w-7xl max-h-full flex flex-col items-center",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_111, _toDisplayString(selectedVehicle.value.vehicle_make) + " " + _toDisplayString(selectedVehicle.value.vehicle_model) + " " + _toDisplayString(selectedVehicle.value.vehicle_year), 1),
                        _createElementVNode("p", _hoisted_112, " Plate: " + _toDisplayString(selectedVehicle.value.plate_number), 1)
                      ]),
                      _createElementVNode("div", _hoisted_113, " Photo " + _toDisplayString(currentVehiclePhotoIndex.value + 1) + " of " + _toDisplayString(selectedVehicle.value.vehicle_photos?.length || 0), 1)
                    ])
                  ]),
                  (selectedVehicle.value.vehicle_photos && selectedVehicle.value.vehicle_photos[currentVehiclePhotoIndex.value])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: getPhotoUrl(selectedVehicle.value.vehicle_photos[currentVehiclePhotoIndex.value].photo_path),
                        alt: `Vehicle Photo ${currentVehiclePhotoIndex.value + 1}`,
                        class: "max-w-full max-h-[calc(100vh-200px)] object-contain rounded-lg shadow-2xl"
                      }, null, 8, _hoisted_114))
                    : _createCommentVNode("", true)
                ]),
                (selectedVehicle.value.vehicle_photos && currentVehiclePhotoIndex.value < selectedVehicle.value.vehicle_photos.length - 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _withModifiers(nextVehiclePhoto, ["stop"]),
                      class: "absolute right-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                    }, _cache[66] || (_cache[66] = [
                      _createElementVNode("svg", {
                        class: "h-12 w-12",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M9 5l7 7-7 7"
                        })
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                (selectedVehicle.value.vehicle_photos && selectedVehicle.value.vehicle_photos.length > 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 bg-black bg-opacity-75 p-3 rounded-lg max-w-full overflow-x-auto",
                      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedVehicle.value.vehicle_photos, (photo, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: photo.vehicle_photo_id,
                          onClick: ($event: any) => (currentVehiclePhotoIndex.value = index),
                          class: _normalizeClass(["flex-shrink-0 w-16 h-16 rounded-md overflow-hidden border-2 transition-all duration-200", currentVehiclePhotoIndex.value === index ? 'border-white scale-110' : 'border-gray-600 opacity-60 hover:opacity-100'])
                        }, [
                          _createElementVNode("img", {
                            src: getPhotoUrl(photo.photo_path),
                            alt: `Thumbnail ${index + 1}`,
                            class: "w-full h-full object-cover"
                          }, null, 8, _hoisted_116)
                        ], 10, _hoisted_115))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "modal" }, {
        default: _withCtx(() => [
          (showTireRejectModal.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4",
                onClick: closeTireRejectModal
              }, [
                _createElementVNode("div", {
                  class: "bg-white dark:bg-black rounded-lg shadow-xl max-w-md w-full p-6",
                  onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _cache[67] || (_cache[67] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-4" }, "Reject Tire Registration", -1)),
                  _cache[68] || (_cache[68] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400 mb-4" }, " Please provide a reason for rejecting this tire registration: ", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((tireRejectionReason).value = $event)),
                    rows: "4",
                    class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white",
                    placeholder: "Enter rejection reason..."
                  }, null, 512), [
                    [_vModelText, tireRejectionReason.value]
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("button", {
                      onClick: closeTireRejectModal,
                      class: "px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-black rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                    }, " Cancel "),
                    _createElementVNode("button", {
                      onClick: confirmTireReject,
                      disabled: !tireRejectionReason.value.trim(),
                      class: "px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    }, " Reject Tire ", 8, _hoisted_118)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 64))
}
}

})